import { SPONSORED_RECO_ACTIONS } from '../../actions/sponsoredRecoActions';

const sponsoredRecoReducer = (state = {
  imagesLoaded: 0,
  imagesToBeLoaded: 1,
  reco: null,
}, action) => {
  switch (action.type) {
    case SPONSORED_RECO_ACTIONS.FETCH_DATA:
      if (action.payload.length) {
        state = {
          ...state,
          reco : action.payload,
        }
      }
      break;
    case SPONSORED_RECO_ACTIONS.IMAGE_LOADED:
      if (state.imagesLoaded < state.imagesToBeLoaded) {
        state = {
          ...state,
          imagesLoaded: state.imagesLoaded + 1
        }
      }
      break;
    default:
      break;
  }
  return state;
};

export default sponsoredRecoReducer;
